import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgContinuousSupportIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="currentColor"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M11.624 8.127a2.86 2.86 0 0 0-1.872.466L6.924 10.48c-1.952 1.301-2.54 3.986-1.198 5.937 4.923 7.164 10.691 12.932 17.855 17.855 1.951 1.341 4.636.754 5.937-1.198l1.888-2.829a2.874 2.874 0 0 0-.358-3.616l-2.357-2.357a3.154 3.154 0 0 0-3.633-.589l-1.731.866a1.476 1.476 0 0 1-1.71-.277l-5.891-5.892a1.475 1.475 0 0 1-.277-1.709l.866-1.732a3.154 3.154 0 0 0-.59-3.632L13.37 8.95a2.863 2.863 0 0 0-1.745-.824Zm-.947 1.853a1.191 1.191 0 0 1 1.514.15l2.356 2.356c.453.452.563 1.137.277 1.71l-.866 1.73a3.154 3.154 0 0 0 .59 3.634l5.891 5.892a3.154 3.154 0 0 0 3.633.589l1.732-.866a1.475 1.475 0 0 1 1.709.277l2.357 2.356c.408.408.47 1.034.15 1.514l-1.889 2.829c-.801 1.202-2.434 1.554-3.606.748-7.008-4.816-12.61-10.417-17.426-17.425-.805-1.172-.453-2.805.75-3.606z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M27.5 5C23.368 5 20 8.368 20 12.5s3.368 7.5 7.5 7.5 7.5-3.368 7.5-7.5S31.632 5 27.5 5Zm0 1.667a5.82 5.82 0 0 1 5.833 5.833 5.82 5.82 0 0 1-5.833 5.833 5.82 5.82 0 0 1-5.833-5.833A5.82 5.82 0 0 1 27.5 6.667Z"
    />
    <path
      stroke="currentColor"
      strokeWidth={0.3}
      d="M27.5 8.334a.833.833 0 0 0-.834.833v3.334c0 .22.088.433.245.589l2.5 2.5a.833.833 0 0 0 1.178-1.178l-2.256-2.256V9.167a.833.833 0 0 0-.833-.833Z"
    />
  </svg>
);
export default SvgContinuousSupportIcon;
